/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type BatchType = typeof BatchType[keyof typeof BatchType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchType = {
  DISTRIBUTION: 'DISTRIBUTION',
  ORDER: 'ORDER',
} as const;
